import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="footer-about">
              <h3>707 M CO., LTD.</h3>
              <p>จำหน่ายกระติกสูญญากาศคุณภาพสูง สำหรับทั้งตลาดในประเทศและส่งออก</p>
              <p>ผู้เชี่ยวชาญด้านการผลิตภาชนะบรรจุภัณฑ์และเครื่องใช้บนโต๊ะอาหารที่ทำจากแก้ว</p>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="footer-links">
              <h3>ลิงก์ด่วน</h3>
              <ul>
                <li><Link to="/">หน้าหลัก</Link></li>
                <li><Link to="/about">เกี่ยวกับบริษัท</Link></li>
                <li><Link to="/contact">ติดต่อเรา</Link></li>
                <li><Link to="/privacy">นโยบายความเป็นส่วนตัว</Link></li>
                <li><Link to="/terms">เงื่อนไขการใช้บริการ</Link></li>
              </ul>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="footer-contact">
              <h3>ข้อมูลการติดต่อ</h3>
              <p><strong>ที่อยู่:</strong> 968 อาคารอื้อจือเหลียง ชั้นที่ 5 ถนนพระรามที่ 4 แขวงสีลม เขตบางรัก กรุงเทพมหานคร 10500</p>
              <p><strong>โทรศัพท์:</strong> +66 2 234 5678</p>
              <p><strong>อีเมล:</strong> info@707m.co.th</p>
              <p><strong>ทะเบียน:</strong> 0105567253957</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-12">
              <p className="text-center">
                &copy; {new Date().getFullYear()} 707 M CO., LTD. สงวนลิขสิทธิ์ทั้งหมด
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
